import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_minnesota_proud_local_feeling_gifts: FaireThemeEntity =
  {
    token: "rustic-depot-minnesota-proud-local-feeling-gifts",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Minnesota Proud",
    description: "State pride gifts that resonate with your local base",
    bgColor: "#C8D5E0",
    tileBgColor: "#003865",
    productTokens: [
      "p_9kn52guu3u",
      "p_dszk99fapg",
      "p_4fryh5djpm",
      "p_43rwanydq9",
      "p_u68c3zzw3v",
      "p_alttfl66jh",
      "p_5fgfosxe9q",
      "p_259bjb48rt",
      "p_jqz8jybkae",
      "p_825ixc01tf",
      "p_kqss3zkgpy",
      "p_8cruayjm6y",
      "p_d6u4myhnjf",
      "p_agm6bquzqj",
      "p_ugznfgr2jn",
      "p_2tagzrm3fx",
      "p_w84yxgx85v",
      "p_zkfru6ned5",
      "p_zzsyaapex7",
      "p_n4xnjmzg7j",
      "p_ft77ghjjhv",
      "p_zp37xzx8eb",
      "p_fcmj6583j9",
      "p_4s9d5yvacb",
      "p_rdw4w8y243",
      "p_rmcp88j5zw",
      "p_4m2nun76sq",
      "p_97su7hdac8",
      "p_ztd8jrk2b3",
      "p_dq3f2amnch",
      "p_ps8bwv76j6",
      "p_x7k9hpxvg3",
      "p_mxx94z3b26",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
